import lodash from 'lodash'
import Base from '../base.store'
/*
import { filter } from "../../../../utils/search";
*/

const baseUrl = '/api/v1/transaction/certificate-products'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        findAllByCertificateId(context, { certificateId }) {
            const select = ['*', 'refSamplingProduct.*']
            const wheres = [
                { name: 'refCertificateRequest.id', operator: '=', type: "UUID", value: certificateId },
                { name: "refCertificateRequest.isActive", type: "Boolean", operator: '=', value: true },
            ]
            const sort = [{ name: 'refSamplingProduct.samplingNo', type: 'ASC' }]
            /*const whereFilter = [
                // { name: 'tax', operator: 'like', type: "String", value: searchQuery },
                // { logic: 'OR', name: 'nameTh', operator: 'like', type: "String", value: searchQuery },
                // { logic: 'OR', name: 'thNo', operator: 'like', type: "String", value: searchQuery },
            ]*/
            return context.dispatch('findAll', { criteria: { select, where: wheres, sort} })
              /*  .then(list => filter({ list: list.map(d => d.refCompany), where: whereFilter }))*/
        }
    },
    mutations: {
        ...base.mutations
    },
}
